import { types } from "../../types/types";

const initialState = {
    diasDisponibles: null,
    turnosDisponibles: null,
    horasDisponibles: null,
    seleccionado: null,
    errorPrimeroDisponible: false,
    stepTurno: 0,
    misTurnos: [],
    historialAtencion: [],
    motivosBaja: null,
    loading: false,
};

export const AfiliadoTurnosReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.traerTurnosDiasStart:
            return {
                ...state,
                loading: true
            }
        case types.traerTurnosDiasSuccess:
            return {
                ...state,
                diasDisponibles: action.payload,
                loading: false
            }
        case types.traerTurnosDiasError:
            return {
                ...state,
                loading: false
            }
        case types.traerTurnosHorasStart:
            return {
                ...state,
                loading: true
            }
        case types.traerTurnosHorasSuccess:
            return {
                ...state,
                horasDisponibles: action.payload,
                loading: false
            }
        case types.traerTurnosHorasError:
            return {
                ...state,
                loading: false
            }
        case types.traerTurnosHorariosStart:
            return {
                ...state,
                loading: true
            }
        case types.traerTurnosHorariosSuccess:
            return {
                ...state,
                turnosDisponibles: action.payload,
                loading: false
            }
        case types.traerTurnosHorariosError:
            return {
                ...state,
                loading: false
            }
        case types.traerPrimerTurnoDisponibleStart:
            return {
                ...state,
                errorPrimeroDisponible: false,
                seleccionado: null,
                loading: true
            }
        case types.seleccionarTurnoAfiliado:
            return {
                ...state,
                seleccionado: action.payload,
                loading: false
            }
        case types.traerPrimerTurnoDisponibleError:
            return {
                ...state,
                errorPrimeroDisponible: true,
                seleccionado: null,
                loading: false
            }
        case types.changeStepperTurnoAfiliado:
            return {
                ...state,
                stepTurno: action.payload
            }
        case types.traerTurnosAfiliadoStart:
            return {
                ...state,
                loading: true
            }
        case types.traerTurnosAfiliadoSuccess:
            return {
                ...state,
                misTurnos: action.payload,
                loading: false
            }
        case types.traerTurnosAfiliadoError:
            return {
                ...state,
                misTurnos: [],
                loading: false
            }
        case types.traerMotivosBajaTurnosStart:
            return {
                ...state,
                loading: true
            }
        case types.traerMotivosBajaTurnosSuccess:
            return {
                ...state,
                motivosBaja: action.payload,
                loading: false
            }
        case types.traerMotivosBajaTurnosError:
            return {
                ...state,
                loading: false
            }
        case types.limpiarDatosDeTurnosParametrosAnteriores:
            return{
                ...state,
                diasDisponibles: null,
                turnosDisponibles: null,
                horasDisponibles: null
            }
        case types.traerHistorialTurnosAfiliadoStart:
            return {
                ...state,
                loading: true
            }
        case types.traerHistorialTurnosAfiliadoSuccess:
            return {
                ...state,
                historialAtencion: action.payload,
                loading: false
            }
        case types.traerHistorialTurnosAfiliadoError:
            return {
                ...state,
                historialAtencion: [],
                loading: false
            }
        default:
            return state;
    }
};